import { DataViewDesignTokens } from '@primeuix/themes/aura/dataview';

export const dataViewTokens: DataViewDesignTokens = {
  root: {
    borderColor: 'transparent',
    borderWidth: '0',
    borderRadius: '0',
    padding: '0',
  },
  header: {
    background: '{content.background}',
    color: '{content.color}',
    borderColor: '{content.border.color}',
    borderWidth: '1',
    borderRadius: '0',
    padding: '0.75rem 1rem',
  },
  content: {
    background: '{content.background}',
    color: '{content.color}',
    borderColor: 'transparent',
    borderRadius: '0',
    borderWidth: '0',
    padding: '0',
  },
  footer: {
    background: '{content.background}',
    color: '{content.color}',
    borderColor: '{content.border.color}',
    borderWidth: '1',
    borderRadius: '0',
    padding: '0.75rem 1rem',
  },
  paginatorTop: {
    borderColor: '{content.border.color}',
    borderWidth: '1',
  },
  paginatorBottom: {
    borderColor: '{content.border.color}',
    borderWidth: '1',
  },
};
